import React from 'react'
import { formatPrice } from '@wellbeingxltd/fe-lib/helpers'

const renderStatus = status => {
    let className = 'textPill '
    switch (status) {
        case 'PAID':
            className += 'textPill--green'
            break
        case 'DRAFT':
        case 'NOT PAID':
            className += 'textPill--grey'
            break

        default:
            break
    }

    if (!status) {
        return null
    }

    return <span className={className}>{status}</span>
}

export const invoicesColumns = [
    {
        Header: 'Date',
        accessor: 'date',
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Client',
        accessor: 'clientName',
        Cell: props => props.value || '-',
        style: {
            width: '20%',
        },
    },
    {
        Header: 'Supplier',
        accessor: 'supplierName',
        Cell: props => props.value || '-',
        style: {
            width: '20%',
        },
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        Cell: props => formatPrice(props.value),
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: props => renderStatus(props.value),
        style: {
            width: '20%',
        },
    },
    {
        Header: 'View PDF',
        accessor: 'pdf',
        Cell: props => (
            <a target="_blank" href={props.value} data-analyticslink={true} rel="noreferrer">
                PDF Link
            </a>
        ),
        style: {
            width: '20%',
        },
    },
]

export const licenseColumns = [
    {
        Header: 'Date',
        accessor: 'date',
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Description',
        accessor: 'description',
        Cell: props => `${props.row.original.supplierName} monthly license fees`,
        style: {
            width: '30%',
        },
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        Cell: props => formatPrice(props.value),
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: props => renderStatus(props.value),
        style: {
            width: '20%',
        },
    },
    {
        Header: 'Download CSV',
        accessor: 'csv',
        Cell: props => {
            const csv = props.value
            if (csv) {
                return (
                    <a target="_blank" href={csv} data-analyticslink rel="noreferrer">
                        Download CSV
                    </a>
                )
            } else {
                return <span>-</span>
            }
        },
        style: {
            width: '20%',
        },
    },
    {
        Header: 'View PDF',
        accessor: 'pdf',
        Cell: props => (
            <a target="_blank" href={props.value} data-analyticslink rel="noreferrer">
                View PDF
            </a>
        ),
        style: {
            width: '20%',
        },
    },
]

export const summariesColumns = [
    {
        Header: 'Date',
        accessor: 'date',
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Description',
        accessor: 'description',
        Cell: props => `${props.row.original.supplierName} monthly summary`,
        style: {
            width: '30%',
        },
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        Cell: props => formatPrice(props.value),
        style: {
            width: '10%',
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: props => renderStatus(props.value),
        style: {
            width: '20%',
        },
    },
    {
        Header: 'Download CSV',
        accessor: 'csv',
        Cell: props => {
            const csv = props.value
            if (csv) {
                return (
                    <a target="_blank" href={csv} data-analyticslink rel="noreferrer">
                        Download CSV
                    </a>
                )
            } else {
                return <span>-</span>
            }
        },
        style: {
            width: '20%',
        },
    },
    {
        Header: 'View PDF',
        accessor: 'pdf',
        Cell: props => (
            <a target="_blank" href={props.value} data-analyticslink rel="noreferrer">
                View PDF
            </a>
        ),
        style: {
            width: '20%',
        },
    },
]
